import React from 'react';

import DeskNav from '../layouts/DeskNav';

import '../../styles/contact.scss';
import LinkedInLogo from '../../images/linkedin-logo.svg';
import PdfIcon from '../../images/pdf-icon.svg';
import Resume from '../../pdf/Alejandro_Alfaro_Resume.pdf';

export default (props) => {
	return (
		<main className='contact'>
			<DeskNav />
			<section>
				<h2> {props.contact.title} </h2>
				<p><span>{props.contact.phone.title}</span> {` ${props.contact.phone.number}`} </p>
				<p><span>{props.contact.email.title}</span> {` ${props.contact.email.email}`} </p>
				<a href={props.contact.linkedin.url}><LinkedInLogo alt={props.contact.email.title} /></a>
				<a href={Resume} download={props.contact.pdf.name}> <PdfIcon /></a>
			</section>
		</main>
	);
};